module.exports = __webpack_public_path__ + "img/unfillcertificate.272c6efb.jpg";